<template>
  <section class="py-[60px] xl:py-[140px]" id="features">
    <div class="container">
      <SectionTitle
        title-class="!mb-0"
        :title="$t('landing.benefits.title')"
        class="mx-auto text-center xl:mb-14 mb-8"
      >
        <p
          class="text-dark text-base max-w-[800px] mx-auto"
          v-html="$t('landing.benefits.description')"
        />
      </SectionTitle>
      <div
        class="benefits-gradient rounded-[36px] p-8 w-full grid sm:grid-cols-2 md:grid-cols-3 gap-10"
      >
        <CardBenefit
          v-for="(benefit, idx) in benefits"
          :key="idx"
          v-bind="{ benefit }"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { benefits } from "@/data/index";
import SectionTitle from "@/modules/Landing/components/Common/SectionTitle.vue";
import CardBenefit from "@/modules/Landing/components/Card/Benefit.vue";
</script>

<style scoped>
.benefits-gradient {
  background: linear-gradient(
    180deg,
    #edfaff 10.54%,
    rgba(244, 246, 229, 0.89) 107.64%
  );
}
</style>
